export default __webpack_public_path__ + "static/media/Banner.a4f30c1a.jpg";